<template>
  <div class="home" v-if="orderInfo">
    <div class="main-content" v-if="isMaxScreen">
      <div class="order-information">
        <div class="order-information-title">{{ $t('component.tradeInProcess.orderInfor') }}</div>
        <div class="order-list">
          <div
            v-for="(item, index) in orderInfoList"
            :key="index"
            class="order-item"
            v-if="shouldShowItem(item)"
          >
            <span class="order-item-left">{{ item.title }}</span>
            <span class="order-item-right"
              >{{ item.coin ? orderInfo[item.coin] : '' }}
              {{
                item.content === 'orderTime'
                  ? formatTime(orderInfo[item.content])
                  : orderInfo[item.content]
              }}</span
            >
          </div>
          <div v-if="!orderInfo.bonusSwitch" class="bonusSwitch">
            {{ $t('components.tradeInProcess.656g0lj3sf6e') }}
          </div>
        </div>
      </div>
    </div>
    <div class="main-content" v-else>
      <!-- trade-in-process -->
      <div class="order-information">
        <h5>{{ $t('component.tradeInProcess.orderInfor') }}</h5>
        <div
          v-for="(item, index) in orderInfoList"
          :key="index"
          class="order-item"
          v-if="shouldShowItem(item)"
        >
          <span class="order-item-left">{{ item.title }}</span>
          <div class="order-item-right">
            <span class="order-item-right-text"
              >{{ orderInfo[item.coin] }}
              {{
                item.content === 'orderTime'
                  ? formatTime(orderInfo[item.content])
                  : orderInfo[item.content]
              }}</span
            >
          </div>
        </div>
        <div v-if="!orderInfo.bonusSwitch" class="bonusSwitch">
          {{ $t('components.tradeInProcess.656g0lj3sf6e') }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { vm } from "@/locales"
import { formatDate } from '@/utils/util'
export default {
  name: 'tradeInProcess',
  components: {},
  props: {
    orderInfo: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      orderInfoList: [
        { title: vm.$t('component.tradeInProcess.orderID'), content: 'orderNum' },
        { title: vm.$t('component.tradeInProcess.createTime'), content: 'orderTime' },
        { title: vm.$t('component.tradeInProcess.brand'), content: 'estimatedBrand' },
        { title: vm.$t('component.tradeInProcess.model'), content: 'estimatedModel' },
        { title: 'ROM/RAM', content: 'estimatedMemory' },
        { title: 'IMEI', content: 'imeiSn' },
        { title: vm.$t('component.tradeInProcess.price'), content: 'estimatedEvaluation', coin: 'currency' },
        { title: vm.$t('component.tradeInProcess.bonus'), content: 'estimatedBonus', coin: 'currency' },
        { title: vm.$t('component.tradeInProcess.total'), content: 'totalPrice', coin: 'currency' },
        { title: vm.$t('component.tradeInProcess.expertDiscount'), content: 'expertDiscount', coin: 'currency' }
      ]
    };
  },
  computed: {
    ...mapState({
      isMaxScreen: state => {
        return state.isMaxScreen;
      }
    }),

   
  },
  methods: {
    formatTime(time){
      return formatDate(time, 'y-m-d-h-mm-s')
    },
    shouldShowItem(item) {
      const { content } = item;
      const value = this.orderInfo[content];

      switch (content) {
        case 'expertDiscount':
          return value !== 0; // 为 0 时不显示

        case 'totalPrice':
          // 在 bonusSwitch 为 false 或值为 0 时不显示
          return !(!this.orderInfo.bonusSwitch || value === 0);

        case 'estimatedBonus':
          // 在 bonusSwitch 为 false 或值为 0 时不显示
          return !(!this.orderInfo.bonusSwitch || value === 0);

        default:
          return true;
      }
    }
  }
};
</script>
<style scoped lang="less">
@media (max-width: 980px) {

  .bonusSwitch{
    color: #999;
    font-family: "PingFang SC";
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    margin: 0px 32px 24px;
    font-size: 28px;
  }

  h5 {
    color: var(---Text-1, #252629);
    font-family: 'PingFang SC';
    font-size: 32px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    padding: 32px;
    margin: 0;
    text-align: left;
  }

  .order-information {
    width: 686px;
    // height: 412px;
    flex-shrink: 0;
    border-radius: 24px;
    background: #fff;
    margin: 24px auto;
    overflow: hidden;

    .order-item {
      display: flex;
      justify-content: space-between;
      margin: 0px 32px 24px;
    }

    .order-item-left {
      width: 270px;
      text-align: left;
      color: #666;
      font-size: 28px;
      // display: block;
      display: flex;
      align-items: center;
    }

    .order-item-right {
      font-size: 28px;
      width: 4rem;
      display: flex;
      align-items: center;
    }

    .order-item-right-text {
      color: #666;
      font-size: 28px;
      // display: flex;
      align-items: center;
      word-wrap: break-word; /* 适用于大多数现代浏览器 */
      overflow-wrap: break-word; /* 适用于支持旧版规范的浏览器 */
      width: 4rem;
      text-align: right;
    }
  }
}
@media (min-width: 981px) {

  .bonusSwitch{
    color: #999;
    font-family: "PingFang SC";
    font-size: 21px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }
  .order-information-title {
    color: #252629;
    font-family: 'PingFang SC';
    font-size: 45px;
    font-weight: 600;
    text-align: center;
    margin: 60px 0 30px 0;
  }

  .main-content {
    width: 100%;
    background: rgba(217, 217, 217, 0.2);
  }

  .order-information {
    flex-shrink: 0;

    overflow: hidden;
    width: 1680px;
    margin: 0 auto;
    // height: 570px;

    .order-list {
      display: flex;
      flex-wrap: wrap;
      margin-bottom: 60px;
    }

    .order-item {
      display: flex;
      flex-direction: column;
      // margin: 0px 32px 24px;
      width: 25%;
      margin-bottom: 17px;
    }

    .order-item-left {
      text-align: left;
      color: #333;
      font-family: 'PingFang SC';
      font-size: 24px;
      font-weight: 600;
      margin-bottom: 10px;
      display: block;
    }

    .order-item-right {
      color: #666;
      font-family: 'PingFang SC';
      font-size: 21px;
      font-weight: 400;
      flex: 1;
    }
  }
}
</style>
